module.exports = __webpack_public_path__ + "img/planes-frame.2f3ebff0.gif";